module.exports = __webpack_public_path__ + "media/images/application/icons/icon-arrow-select-03edae357328578a23b8c673340c18a9.svg";